// extracted by mini-css-extract-plugin
export default {"displayNotesCard":"DisplayHome_displayNotesCard__7YWWt","homeImage":"DisplayHome_homeImage__PgCF2","appName":"DisplayHome_appName__JBASk"};